<template>
    <v-container fluid>
      <v-row>
          <template v-for="(menu_, index) in opciones_menu">
              <v-col cols="12" md="6">
                  <v-card outlined>
                      <v-list two-line class="pb-0 pt-0">
                          <v-list-item :to="{name: menu_.link, params: menu_.params }">
                              <v-list-item-avatar>
                                  <v-icon>{{ menu_.icon }}</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                  <v-list-item-title>{{ menu_.title }}</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <v-btn icon :to="{name: menu_.link}">
                                      <v-icon color="grey lighten-1">mdi-arrow-right</v-icon>
                                  </v-btn>
                              </v-list-item-action>
                          </v-list-item>
                      </v-list>
                  </v-card>
              </v-col>
          </template>
      </v-row>
    </v-container>
</template>

<script>

export default {
  components: { 
  },
  data: function() {
    return {
      usuario_admin : [
        { title: 'Empresa', icon: 'mdi-domain', link: 'admin_agrupador', params: {'id': this.$store.state.user.agrupador_id }},
      ],
      menu_admin : [
        { title: 'Parámetros', icon: 'mdi-tune', link: 'admin_parametros', params:{} },
        { title: 'Empresas (agrupador)', icon: 'mdi-domain', link: 'admin_agrupadores', params:{}},
        { title: 'Roles', icon: 'mdi-account-group', link: 'admin_roles', params:{}},
        { title: 'Planes', icon: 'mdi-cog-transfer-outline', link: 'admin_planes', params:{}},
        { title: 'Recargas a planes', icon: 'mdi-currency-usd', link: 'admin_recargas', params:{} },
      ],
      opciones_menu: []
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {
    if(this.$store.state.user.is_admin) {
      this.opciones_menu = this.menu_admin;
    }
    else if(this.$store.state.user.is_usuario_administrador) {
     this.opciones_menu = this.usuario_admin; 
    }
  },
  mounted() {

  },
  methods: {

  },
};
</script>